import { Container, Row, Col, Card } from 'react-bootstrap';
import logo from "../../../images/logo-nero-sportid.svg";

// Pagina pubblica di esito raggiunta dai link nelle email (verifica indirizzo,
// cancellazione account). La vedono soprattutto gli utenti dell'app, quindi
// niente menu né login del manager: solo il messaggio.
const PaginaEsito = ({ titolo, variante = 'success', children }) => {
    // Testi sempre neri e leggibili (regola SUI); il tipo di esito lo dice una riga colorata sopra il titolo
    const colore = variante === 'danger' ? '#C62828' : '#E38100';

    return (
        <div className="min-vh-100 d-flex align-items-center py-4" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
                <Row className="justify-content-center">
                    <Col md={8} lg={6}>
                        <Card className="shadow-sm border-0">
                            <Card.Body className="p-4 p-md-5 text-center">
                                <img src={logo} alt="SportId" style={{ height: '60px' }} className="mb-4" />
                                <div style={{ width: '48px', height: '4px', borderRadius: '4px', background: colore, margin: '0 auto 14px' }} />
                                <h3 className="mb-3" style={{ color: '#1A1A1A' }}>{titolo}</h3>
                                <div className="sid-esito__testo">{children}</div>
                                <div className="mt-4">
                                    <small style={{ color: '#1A1A1A', fontSize: '14px' }}>
                                        Hai bisogno di aiuto? Scrivi a <a href="mailto:hello@sportid.it" style={{ color: "#1A1A1A", textDecoration: "underline" }}>hello@sportid.it</a>
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PaginaEsito;
